// extracted by mini-css-extract-plugin
export var label = "_ep-2";
export var slideContainer = "_ep-0";
export var slider = "_ep-1";